export const ChemicalFlow = React.lazy(() => import(/* webpackChunkName: "ChemicalFlow" */ './fragments/ChemicalFlow'));